import { Image, Text } from "@chakra-ui/react";
import SommingSoonImg from '../../../assets/images/comming-soon.png';

function Voting() {
  return <table className="table" data-category="voting" hidden>
    <tr className="table__row comming no-data_container"><Image src={SommingSoonImg} /> </tr>
  </table>;
}

export default Voting;